import { useContext, useRef, useState } from 'react';
import { useHistory } from 'react-router-dom';
import StudentImage from '../../../models/StudentImage';
import useLocalStorage from '../../../hooks/useLocalStorage';
import { CustomerContext } from '../../../contexts/CustomerContext';

export default function useFacialRecognition() {
  const history = useHistory();
  const ref = useRef(null);
  const { customer, setCustomer } = useContext(CustomerContext);
  const [studentImageFile, setStudentImageFile] = useState(null);
  const [_isUsingAccessCode, setIsUsingAccessCode] = useLocalStorage('isUsingAccessCode');
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [studentImage, setStudentImage] = useState();
  const [noStudentFound, setNoStudentFound] = useState(false);
  const [attachedFile, setAttachedFile] = useState();

  const handleContinue = (image) => {
    setIsSubmitting(true);

    setCustomer({ ...customer, currentStudent: image.student, currentSchool: image.student.school });
    history.push(`/package_selection${image && image.packageId ? `?pid=${image.packageId}` : ''}`);
  };

  const handleSubmit = async () => {
    if (!studentImageFile) return;

    setIsSubmitting(true);
    const data = new FormData();
    data.append('image', ref.current.files[0]);
    data.append('school_id', customer.currentSchool.id);

    let response = await fetch('/api/v1/students/face_match', {
      method: 'POST',
      body: data,
    });

    response = await response.json();

    if (!response.access_code) {
      // handle error
      setIsSubmitting(false);
      setNoStudentFound(true);
      return;
    }

    StudentImage
      .includes({ student: ['school'] })
      .selectExtra(['packageId'])
      .where({ for_access_code_and_school: [response.access_code, response.school_id] })
      .all()
      .then((res) => {
        const studentImageRes = res.data.sort((a, b) => a.createdAt.localeCompare(b.createdAt))[res.data.length - 1];

        setIsUsingAccessCode(true);
        setStudentImage(studentImageRes);
        setIsSubmitting(false);
      });
  };

  return ({
    attachedFile,
    handleSubmit,
    handleContinue,
    isSubmitting,
    ref,
    setAttachedFile,
    setStudentImageFile,
    studentImageFile,
    studentImage,
    noStudentFound,
  });
}
